module.exports = __webpack_public_path__ + "static/img/son1_active.5c464c50.png";